import { useContext, useEffect, useRef, useState } from "react";
import { Button } from "@atoms";
import { AuthContext } from "@auth";

export type UserInfoCardTemplateProps = {
  onClick: any;
};

export const UserInfoCardTemplate = ({
  onClick,
}: UserInfoCardTemplateProps): JSX.Element => {

  const { partner, signOut } = useContext(AuthContext);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement | null>(null);

  const getUserInitials = (firstName: string, lastName: string): string =>
  firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();

  let userInitials = "";
  if (partner) {
    userInitials = getUserInitials(partner?.firstName, partner?.lastName);
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleMenu = (): void => {
    setIsMenuOpen((prev) => !prev);
  };

  const handleSignOut = async (): Promise<void> => {
    setIsMenuOpen(false);
    await signOut();
  };

  const handleContainerClick = (): void => {
    toggleMenu();
    onClick?.();
  };

  return (
    <div
      className="group flex flex-row w-full h-auto max-w-max items-center justify-start cursor-pointer"
      ref={containerRef}
      onClick={handleContainerClick}
    >
      <div className="relative mr-3">
        <Button
          variant="avatar"
          label={userInitials || "?"}
          className="group-hover:bg-neutral-mediumDark group-hover:text-white"
          onClick={(e) => {
            e.stopPropagation();
            toggleMenu();
          }}
        />
        {isMenuOpen && (
          <div
            className="absolute z-20 bottom-full left-0 mb-2 w-32 rounded-lg border border-neutral-light bg-white py-1 text-sm shadow-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="w-full px-3 py-2 text-left text-neutral-darkest hover:text-primary-medium"
              onClick={handleSignOut}
            >
              Sign out
            </button>
          </div>
        )}
      </div>
      <div className="flex flex-col">
        <div className="font-semibold text-sm leading-5 text-neutral-darkest">{`${partner?.firstName} ${partner?.lastName}`}</div>
        <div
          className="font-normal text-neutral-dark"
          style={{ fontSize: "11px", lineHeight: "16px" }}
        >
          {partner?.emailAddress}
        </div>
      </div>
    </div>
  );
};
